import React from 'react'
import Fade from 'react-reveal/Fade'
import { areas } from '../../assets/imgs'
import './index.css'

const data = [{
  title: 'Criminal Defense',
  desc: 'Sound, strategic criminal defense representation for all state and federal criminal matters.'
}, {
  title: 'General Litigation',
  desc: 'A diversified practice including, but not limited to, immigration matters, contractual disputes, arbitration/mediation, and residential real estate transactions.'
}, {
  title: 'Civil Rights Actions',
  desc: 'State and federal civil rights actions involving claims of employment discrimination, police brutality, false arrest, malicious prosecution, and wrongful death.'
}]

const Areas = () =>
  <Fade>
    <div className="areas relative m0-auto">
      <div className="areas__img-container relative flex flex-row justify-center items-center pa0 absolute-l din-l pa0-l">
        <img src={areas} className="areas__img db" alt="areas" />
        <div className="areas__disclaimer absolute fw2">Fictionalized Depiction</div>
      </div>
      <div className="areas__content bg-red pa3 pa4-m absolute-l">
        <h2 className="serif f3 fw4 white mb5 f1-ns">Holistic, client-centered:</h2>
        {data.map(({ title, desc }, i) => (
          <div className="mb4" key={i}>
            <h3 className="fw3 f5 white mb2 f2-ns">{title}</h3>
            <p className="fw2 f6 white f2 f4-ns">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </Fade>

export default Areas



// WEBPACK FOOTER //
// ./src/components/areas/index.js